var _defs, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aturna-logo-polygon-1{fill:#FFFFFF;}.aturna-logo-polygon-2{fill:#AAF08C;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "aturna-logo-polygon-1",
    points: "1170.44 340 829.56 340 419.53 1601.96 674.56 1601.96 1000 600.34 1107.54 931.32 1362.56 931.32 1170.44 340"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "aturna-logo-polygon-2",
    points: "1409.31 1075.21 1049.41 1075.1 873.2 1317.64 1233.1 1317.75 1344.41 1660 1520.63 1417.45 1409.31 1075.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.3e6db2fb8a88fa35a99f92695395325e.svg";
export { ForwardRef as ReactComponent };